import { configureStore } from '@reduxjs/toolkit'
import profileSlice from './slice/profile.slice'

export default configureStore({
  reducer: {
    profile: profileSlice,
  },
 
})
